export const headCellDistributionBySite = [
  {
    id: "idDistribution",
    disablePadding: false,
    label: "Lote de distribución",
  },
  { id: "category", disablePadding: false, label: "Categoría" },
  { id: "subcategory", disablePadding: false, label: "Subcategoría" },
  { id: "product", disablePadding: false, label: "Producto" },
  { id: "imeiCode", disablePadding: false, label: "IMEI" },
  {
    id: "personDeliver",
    disablePadding: false,
    label: "Código de barras/Lote(Chip)",
  },
  { id: "status", disablePadding: false, label: "Estatus" },
  { id: "date", disablePadding: false, label: "Última actualización" },
];
